import React from 'react'
import Section, { StyledSpan } from './Section'
import { ContactPageNumber } from '../../constants'

const ContactInfoSection = ({ prospect, navigatePageWithState, experienceState, globalState, offer, canEdit, calculateViewChange, isError, contactInfo }) => {
  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString.replace('+1 ', '')).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }
  const showContact = !experienceState.isAdmin ? true : experienceState.dealerInfo.isConsumerOffer || (offer && offer.prospect && offer.prospect.isConsumerOffer) ? true : false

  const phone = contactInfo && contactInfo.phone && formatPhoneNumber(contactInfo.phone)
  const zip = (globalState.updatedZip && globalState.zip) || (contactInfo ? contactInfo.zip : undefined)
  let uniqueViewStr = contactInfo && showContact && 'uniqueViewStr:' + contactInfo.firstName + contactInfo.lastName + contactInfo.email + phone + zip

  calculateViewChange('contactInfo', uniqueViewStr)
  return contactInfo && showContact ? (
    <>
      <Section title={'Contact Information'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: ContactPageNumber })} isError={isError}>
        <StyledSpan>First Name: </StyledSpan>
        {contactInfo.firstName}
        <br />
        <StyledSpan>Last Name: </StyledSpan>
        {contactInfo.lastName}
        <br />
        <StyledSpan>Email Address: </StyledSpan>
        {contactInfo.email}
        <br />
        <StyledSpan>Phone Number: </StyledSpan>
        {phone}
        <br />
        <StyledSpan>ZIP Code: </StyledSpan>
        {zip}
      </Section>
    </>
  ) : null
}

export default ContactInfoSection
